import { useEffect, useState } from "react"

function useParallax(wrapperRef) {
  const [offset, setOffset] = useState(null)
  const listener = () => {
    const scrollOfwrapperRef =
      window.pageYOffset - wrapperRef.current.offsetTop + wrapperRef.current.clientHeight / 2

    const hasScrolledTowrapperRef =
      window.pageYOffset - wrapperRef.current.offsetTop + wrapperRef.current.clientHeight > 0
    const hasScrolledwrapperRefAway =
      window.pageYOffset - wrapperRef.current.offsetTop - wrapperRef.current.clientHeight > 0
    if (!hasScrolledTowrapperRef || hasScrolledwrapperRefAway) return
    setOffset(scrollOfwrapperRef)
  }

  useEffect(() => {
    if (offset === null) listener()
    window.addEventListener("scroll", listener)
    return () => {
      window.removeEventListener("scroll", listener)
    }
  })

  return { offset }
}

export { useParallax }
